import { IApplicationState } from '../../types/redux';

export const getUser = ({ user }: IApplicationState) => {
  return {
    userId: user.userId || undefined,
  };
};
